import type { RecipeItemState } from '../../../../recipe/models';

export const getRecipeSection = (item: RecipeItemState) => {
    return {
        recipeId: item.group === 'singleProducts' ? item.belongsToRecipes[0].code : 'shared',
        recipeName: item.group === 'singleProducts' ? item.belongsToRecipes[0].name : 'shared',
    };
};
